/**
 * In this file, we create a React component
 * which incorporates components provided by Material-UI.
 */
import React from 'react';
import queryString from 'query-string';
import { Container, Row, Col } from 'reactstrap';

import { WithLocalize } from '../../containers/I18nProvider';
import RequestLoginErrorMessage from '../../components/RequestLoginErrorMessage';
import ServiceApi from '../../services/ServiceApi';

import './style.scss';
import LoginForm from './LoginForm';


class Login extends React.Component {

  constructor(props, context) {
    super(props, context);

    this.api = new ServiceApi(this);
    this.parameters = queryString.parse(props.location.search);

  }

  _validateParams() {
    if (!this.parameters.client_id || !this.parameters.redirect_uri || !this.parameters.response_type) {
      return false;
    }
    return true;
  }

  componentDidMount() {
    document.title = 'Cinépolis KLIC - Inicia Sesión';
    document.body.style.backgroundColor = 'black'
    // document.body.style.backgroundPosition = 'center'
  }

  render() {
    const { translate } = this.props;

    return (
      <Container fluid={true} className="cnp-body">
        <Row>
          <Col sm="4"></Col>
          <Col sm="4">
            {
              this._validateParams()
                ? <LoginForm
                  api={this.api}
                  location={this.props.location}
                />
                : <RequestLoginErrorMessage
                  onlyMessage={true}
                  message={translate('RequestLoginErrorMessage')}
                />
            }
          </Col>
          <Col sm="4"></Col>
        </Row>
      </Container>
    );
  }
}

export default WithLocalize(Login);
